// Copyright Epic Games, Inc. All Rights Reserved.

import { Epic } from "@epic-ui/icons";
import styled from "styled-components";
import { FunctionComponent } from "react";

export interface IEpicIconProps {
  size: string;
  marginBottom?: string;
}

export const EpicIcon: FunctionComponent<IEpicIconProps> = styled(Epic)(
  ({ size, marginBottom }: IEpicIconProps) => ({
    color: "white",
    "font-size": size,
    "margin-bottom": marginBottom || "33px",
  })
);
